export const SidebarCart = function () {

    const sidebarCart = document.querySelector('.sidebar-cart');

    const isCart = document.querySelector('.woocommerce-cart');
    const isCheckout = document.querySelector('.woocommerce-checkout');

    if (sidebarCart !== null && isCart === null && isCheckout === null) {


        const closeSidebarsOverlay = document.querySelector('.close-sidebars-overlay');

        const headerCartOpen = document.querySelectorAll('.headerCart');

        const innerSidebarClose = sidebarCart.querySelector('.sidebar-cart__close');


        const openSidebarCart = () => {
            sidebarCart.classList.add('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.add('close-sidebars-overlay--opened');

        };

        const closeSidebarCart = () => {
            sidebarCart.classList.remove('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.remove('close-sidebars-overlay--opened');
        };

        headerCartOpen.forEach(open => {
            open.addEventListener('click', function (e) {
                e.preventDefault();
                openSidebarCart();
            });
        })

        innerSidebarClose.addEventListener('click', closeSidebarCart);

        closeSidebarsOverlay.addEventListener('click', closeSidebarCart);


    }


};